import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Tabs, Tab, Paper } from '@material-ui/core'

import { isValidString } from '../../../utils/string'
import { sortArrayByName } from '../../../utils/array'

import { getShopList } from '../../../actions/shop'
import {
  getEmployeeList,
  getOnFleetTeams,
  removeWorkerOnFleet,
  getTookanAccountList,
  setTookanAccounts,
  updateTookanAccount,
  createTookanAccount,
  getTookanTeams,
  updateAgentWithTookan,
  createAgentWithTookan,
  deleteTookanAccount,
} from '../../../actions/integration'
import { openErrorMessage } from '../../../actions/message'

import ContainerWithTitleWrapper from '../../HOC/ContainerWithTitle'
import TookanShopInfo from '../../../components/Tookan/TookanShopInfo'
import TookanEmployeeInfo from '../../../components/Tookan/TookanEmployeeInfo'
import TookanTeamInfo from '../../../components/Tookan/TookanTeamInfo'
import ModalDialog from '../../../components/common/ModalDialog'
import { Appcues } from '../../../utils/constants'

const tookanTabs = ['Shop', 'Team', 'Employee']

class Tookan extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 'Shop',
    }
  }

  componentDidMount() {
    this.props.dispatch(getEmployeeList())
    this.props.dispatch(getTookanTeams())
    this.props.dispatch(getShopList()).then((res) => {
      this.getTookanList(res)
    })
  }

  getTookanList = (shops) => {
    let data = {}
    this.props.dispatch(getTookanAccountList()).then((tookanAcounts) => {
      const tookanAcountsValues = (tookanAcounts && tookanAcounts.values) || []
      shops &&
        shops.values &&
        shops.values.length &&
        shops.values.forEach((item) => {
          const tookanAccount = tookanAcountsValues.find((acc) => acc.shopId === item.id) || {}
          data[item.id] = { ...(data[item.id] || {}), ...tookanAccount, shopId: item.id }
        })

      this.props.dispatch(setTookanAccounts(data))
    })
  }

  tookanTabs = tookanTabs.map((tab) => <Tab label={tab} value={tab} />)

  onSave = (data, afterOnSave) => {
    const { shopsList = {} } = this.props.shopReducer

    if (!data.resetTookan) {
      if (!isValidString(data.apiKey)) {
        this.props.dispatch(openErrorMessage('Please enter a valid api key'))

        return
      }
    }
    if (data.id) {
      this.props.dispatch(updateTookanAccount(data)).then((response) => {
        Appcues.track('Tookan Account Updated')
        this.getTookanList(shopsList)
        afterOnSave(response)
      })
    } else {
      this.props.dispatch(createTookanAccount(data)).then((response) => {
        Appcues.track('Tookan Account Created')
        this.getTookanList(shopsList)
        afterOnSave(response)
      })
    }
  }

  linkItem = (employeeId, shopId, teamId, isNew, afterOnSave) => {
    const apiToHit = isNew ? createAgentWithTookan : updateAgentWithTookan

    this.props.dispatch(apiToHit(employeeId, { shopId, teamId })).then((response) => {
      Appcues.track('Tookan Team Linked')
      if (response.tookanAgentId === null && response.syncWithTookan === false) {
        this.confirmModal.handleClickOpen()
        this.setState({
          newWorkerData: { id: employeeId, shopId, teamId },
        })
      } else {
        this.props.dispatch(getEmployeeList())
        this.props.dispatch(getTookanTeams())
      }
      afterOnSave()
    })
  }

  createNewWorker = () => {
    const { newWorkerData } = this.state

    this.props
      .dispatch(
        createAgentWithTookan(newWorkerData.id, {
          shopId: newWorkerData.shopId,
          teamId: newWorkerData.teamId,
        }),
      )
      .then((response) => {
        Appcues.track('New Worker Created')
        this.props.dispatch(getEmployeeList())
        this.props.dispatch(getTookanTeams())

        this.confirmModal.handleClose()
      })
  }

  removeWorker = (employeeId, shopId, teamId, afterOnSave) => {
    this.props
      .dispatch(removeWorkerOnFleet({ id: employeeId, shopId, teamId }))
      .then((response) => {
        Appcues.track('Worker removed from Tookan Team')
        this.props.dispatch(getEmployeeList())
        this.props.dispatch(getOnFleetTeams())

        afterOnSave()
      })
  }

  handleChange = (event, tab) => {
    this.setState({
      activeTab: tab,
    })
  }

  convertTeamToOptions = (teamList) => {
    const options = []

    const { shopsList = {} } = this.props.shopReducer

    teamList.forEach((team) => {
      const { tookanTeamInfo } = team
      console.log(shopsList, 'shopsList')
      const shop =
        (shopsList &&
          shopsList.values &&
          shopsList.values.find((shop) => {
            return shop.id === team.shopId
          })) ||
        {}

      if (tookanTeamInfo) {
        tookanTeamInfo.forEach((teamInfo) => {
          options.push({
            value: `${team.shopId}BLAZE${teamInfo.id}`,
            label: `${shop.name || ''} | ${teamInfo.team_name}`,
          })
        })
      }
    })

    return options
  }

  renderTab = (activeTab) => {
    const { shopsList = {} } = this.props.shopReducer

    const {
      employeeList = {},
      tookanTeamList = {},
      tookanList = {},
    } = this.props.integrationReducer

    const integrationLastModified = this.props.integrationReducer.lastModified

    let employeeListValues = employeeList.values || []

    employeeListValues = sortArrayByName(
      employeeListValues.map((employee) => ({
        ...employee,
        name: `${employee.firstName} ${employee.lastName}`,
      })),
    )

    const teamListOptions = this.convertTeamToOptions(
      (tookanTeamList && tookanTeamList.values) || [],
    )
    //console.log(teamListOptions, "teamListOptions")
    switch (activeTab) {
      case 'Shop':
        return (
          <TookanShopInfo
            tookanList={tookanList}
            onSave={this.onSave}
            lastModified={integrationLastModified}
            shopsList={shopsList}
            onDelete={this.onDelete}
          />
        )
      case 'Employee':
        return (
          <TookanEmployeeInfo
            employeeList={employeeListValues}
            teamList={teamListOptions}
            linkItem={this.linkItem}
            removeWorker={this.removeWorker}
            lastModified={integrationLastModified}
            shopsList={shopsList}
            tookanTeamList={(tookanTeamList && tookanTeamList.values) || []}
          />
        )
      case 'Team':
        return <TookanTeamInfo shopsList={shopsList} lastModified={integrationLastModified} />
      default:
        return null
    }
  }

  onDelete = (accountId) => {
    const { shopsList = {} } = this.props.shopReducer

    this.props.dispatch(deleteTookanAccount(accountId)).then((res) => {
      Appcues.track('Tookan Account Deleted')
      this.getTookanList(shopsList)
    })
  }

  render() {
    const { activeTab } = this.state

    return (
      <div>
        <Paper>
          <Tabs
            value={activeTab}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            centered
          >
            {this.tookanTabs}
          </Tabs>
        </Paper>
        {this.renderTab(activeTab)}
        <ModalDialog
          title={'Warning'}
          ref={(c) => (this.confirmModal = c)}
          onConfirm={this.createNewWorker}
          confirmText={'Yes'}
        >
          <p>This employee doesn't exist, Do you want to create new agent at tookan?</p>
        </ModalDialog>
      </div>
    )
  }
}

const TookanWithTitle = ContainerWithTitleWrapper(Tookan, 'Tookan Management')
const TookanConnected = connect(({ shopReducer, integrationReducer, dispatch }) => ({
  shopReducer,
  integrationReducer,
  dispatch,
}))(TookanWithTitle)

export default TookanConnected



// WEBPACK FOOTER //
// ./src/containers/Settings/Integration/Tookan.js